import React from 'react';
import PropTypes from 'prop-types';

const ListView = ({locationTasks, totalCount}) => {

    return (
        <div className="kanban-view">
            <h2>Kanban View</h2>
            <ul>
                {
                    locationTasks.map(t => <li key={t.id}>{t.name}</li>)
                }
            </ul>
            <p>
                <strong>Total Count: </strong>{totalCount}
            </p>
        </div>
    );
};

ListView.propTypes = {
    locationTasks: PropTypes.array.isRequired,
    totalCount: PropTypes.number.isRequired
}

export default ListView;